import { useAppContext } from '@app-velocity/config';
import { useI18n } from '@app-velocity/i18n';
import { MessageBus } from '@app-velocity/message-bus';
import { Button } from '@app-velocity/ui';

const messageBus = new MessageBus('users');

export const SubscriptionButton = () => {
  const { AVMLink } = useAppContext();
  const { t } = useI18n();

  const handleClick = () => {
    messageBus.publish('modal:user-settings:open', { tab: 'billing' });
  };

  if (AVMLink) {
    return (
      <Button
        fullWidth
        variant="contained"
        color="primary"
        component="a"
        rel="noopener noreferrer"
        href={`${AVMLink}?action=subscription`}
        target="_blank"
      >
        {t('users:no_more_credits.upgrade')}
      </Button>
    );
  }

  return (
    <Button
      fullWidth
      variant="contained"
      color="primary"
      onClick={handleClick}
    >
      {t('users:no_more_credits.upgrade')}
    </Button>
  );
};
